import {
  MemberBadgeCreateRequestDto,
  MemberBadgeDto,
  MemberBadgeUpdateRequestDto,
  PermissionDto,
} from '@careapp-group/ng-sdk-v2-new';
import { BaseFilterType, CaEntityActionsFactory } from '../entity-state/entity-actions-factory';
import { createAction, props } from '@ngrx/store';

class MemberBadgeActions extends CaEntityActionsFactory<
  MemberBadgeDto,
  MemberBadgeCreateRequestDto,
  MemberBadgeUpdateRequestDto,
  BaseFilterType
> {
  constructor() {
    super('MemberBadges');
  }

  // Add badge to permission
  get REQUEST_ADD_BADGE_TO_PERMISSION() {
    return `[${this.type}][Request] Add Badge to Permission`;
  }
  get RESPONSE_SUCCESS_ADD_BADGE_TO_PERMISSION() {
    return `[${this.type}][Response][Success] Add Badge to Permission`;
  }
  get RESPONSE_FAIL_ADD_BADGE_TO_PERMISSION() {
    return `[${this.type}][Response][Fail] Add Badge to Permission`;
  }

  // Remove badge from permission
  get REQUEST_REMOVE_BADGE_FROM_PERMISSION() {
    return `[${this.type}][Request] Remove Badge from Permission`;
  }
  get RESPONSE_SUCCESS_REMOVE_BADGE_FROM_PERMISSION() {
    return `[${this.type}][Response][Success] Remove Badge from Permission`;
  }
  get RESPONSE_FAIL_REMOVE_BADGE_FROM_PERMISSION() {
    return `[${this.type}][Response][Fail] Remove Badge from Permission`;
  }

  // Add badge to permission
  RequestAddBadgeToPermission = createAction(
    this.REQUEST_ADD_BADGE_TO_PERMISSION,
    props<{ permissionId: string; badgeId: string }>()
  );
  ResponseSuccessAddBadgeToPermission = createAction(
    this.RESPONSE_SUCCESS_ADD_BADGE_TO_PERMISSION,
    props<{ payload: PermissionDto }>()
  );
  ResponseFailAddBadgeToPermission = createAction(
    this.RESPONSE_FAIL_ADD_BADGE_TO_PERMISSION,
    props<{ permissionId: string; badgeId: string; error: any }>()
  );

  // Remove badge from permission
  RequestRemoveBadgeFromPermission = createAction(
    this.REQUEST_REMOVE_BADGE_FROM_PERMISSION,
    props<{ permissionId: string; badgeId: string }>()
  );
  ResponseSuccessRemoveBadgeFromPermission = createAction(
    this.RESPONSE_SUCCESS_REMOVE_BADGE_FROM_PERMISSION,
    props<{ payload: PermissionDto }>()
  );
  ResponseFailRemoveBadgeFromPermission = createAction(
    this.RESPONSE_FAIL_REMOVE_BADGE_FROM_PERMISSION,
    props<{ permissionId: string; badgeId: string; error: any }>()
  );
}

export const MemberBadgesActions = new MemberBadgeActions();
